import axios from "axios";
import { config } from "../config";

export default async function postApi(payload) {
  try {
    const headers = { "Content-Type": "application/json" };

    const resp = await axios.post(`${config.apiBaseURL}/common`, { payload: JSON.stringify(payload) }, headers);
    // const resp = await axios.post(`http://localhost:5000/common`, { payload: JSON.stringify(payload) }, headers);
    return resp.data;
  } catch (error) {
    console.log(error);
    return false;
  }
}
